import { AbstractCommand } from 'src/models/command';

class DeleteReceiverGroupCommand extends AbstractCommand {
	override readonly async = false;
	readonly name = 'IFS_Mail_Command_Command_DeleteReceiverGroupCommand';

	public constructor(groupId: number) {
		super();
		this.parameters = {
			groupId: groupId,
		};
	}
}

export { DeleteReceiverGroupCommand };
